import clsx from 'clsx'
import { StarIcon } from 'lucide-react'
import { forwardRef } from 'react'

interface QuoteFeatureToggleProps {
  quoteId: string
  toggled: boolean
  onToggle: (newToggled: boolean) => void
}

export const QuoteFeatureToggle = forwardRef<HTMLInputElement, QuoteFeatureToggleProps>(({ quoteId, toggled, onToggle }, forwardedRef) => {
  return (
    <div className='group inline-flex items-baseline'>
      <div className='relative rounded-lg shadow-[0_0_0_0rem] has-[:hover]:shadow-[0_0_0_0.5rem] group-hover/checkbox-container:shadow-[0_0_0_0.5rem] shadow-transparent has-[:hover]:shadow-gray-800/5 group-hover/checkbox-container:shadow-gray-800/5 has-[:disabled]:has-[:hover]:shadow-transparent transition'>
        <input
          className='peer appearance-none absolute left-0 top-0 w-4 h-4 opacity-0 peer cursor-pointer disabled:cursor-default'
          id={`feature-quote-toggle-${quoteId}`}
          ref={forwardedRef}
          type='checkbox'
          checked={toggled}
          onChange={(event) => onToggle(event.target.checked)}
        />
        <span className='text-gray-500 peer-checked:text-thatch-300'>
          <StarIcon
            size={16}
            className={clsx('transition fill-white', {
              'fill-thatch-500': toggled
            })}
          />
        </span>
      </div>
    </div>
  )
})
